import { useStatQuery } from '@famly/stat_use-stat-query';
import { KinderConnectCaptureFlags } from './kinder-connect-capture-flags.query';
/**
 * Fetches whether KinderConnect TWC media capture (photo, signature, GPS) applies to check-ins/
 * check-outs at a site. Used by `useIsKinderConnectCaptureEnabledForChildren` as a fallback source
 * when the per-child answer errors, so a resolver failure narrows back down to "does this site
 * require it" instead of forcing capture everywhere.
 *
 * @param options - Apollo query options; must include `variables: {siteId}`.
 * @returns The query result, with `data.attendance.childCheckins.kinderConnectCapture` holding
 * `{captureEnabled, captureRequired}` once loaded.
 */
export function useKinderConnectCaptureFlagsQuery(options) {
    return useStatQuery(KinderConnectCaptureFlags, options);
}
